import { Button, createTheme } from '@mantine/core';
import { themeToVars } from '@mantine/vanilla-extract';

export const theme = createTheme({
    primaryColor: 'hha',
    colors: {
        'hha': [
            '#e6eef8',  // 0 - lightest
            '#c9d9f0',  // 1
            '#8FBDEA',  // 2
            '#69A3E1',  // 3
            '#66A7E1',  // 4
            '#2D68C4',  // 5
            '#1A4A96',  // 6 - primary
            '#143A78',  // 7
            '#0f2d5c',  // 8
            '#0a1f40',  // 9 - darkest
        ],
    },
    components: {
        Button: Button.extend({
            defaultProps: {
                color: 'hha',
                variant: 'outline',
            },
        }),
    },
});

export const vars = themeToVars(theme);
